import JassEnum from './enum';

/**
 * type aidifficulty
 */
export default class JassAiDifficulty extends JassEnum {}
